// @flow
import { handleActions } from 'redux-actions';
import type { ActionType } from 'redux-actions';
import types from './types';
import { fetchDataSuccess } from './actions';

export type State = {
    data: Array<number>,
    metadata: Object,
};

export const init: State = {
    data: [],
    metadata: {},
};

export default handleActions({
    [types.FETCH_DATA_SUCCESS]: (state: State, action: ActionType<typeof fetchDataSuccess>) => ({
        ...state,
        data: action.payload,
        metadata: action.meta,
    }),
}, init);
